import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { openQuickAdd, setSearchOpen } from '@/store/ui'

function typing(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null
  if (!el) return false
  const tag = el.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable
}

/** Keyboard: N new task, / search, 1 2 3 for Plan, Calendar and More. Esc is handled by the open sheet. */
export function useShortcuts(): void {
  const navigate = useNavigate()
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey || typing(e.target)) return
      if (document.querySelector('.sheet')) return
      switch (e.key) {
        case 'n':
        case 'N':
          e.preventDefault()
          openQuickAdd()
          break
        case '/':
          e.preventDefault()
          setSearchOpen(true)
          break
        case '1':
          navigate('/plan')
          break
        case '2':
          navigate('/calendar')
          break
        case '3':
          navigate('/settings')
          break
      }
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [navigate])
}
